var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustrationLogo1Bw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 131,
    viewBox: "0 0 151 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6031_788)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.0926 10.0381C117.168 -3.26552 150.109 10.9364 150.109 10.9364V118.003C150.109 118.003 117.168 104.691 76.0926 118.003C35.0168 104.7 0.890869 118.003 0.890869 118.003V10.9364C0.890869 10.9364 35.027 -3.26552 76.0926 10.0381Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5 0.210938V130.211",
    stroke: "black",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6031_788"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150.24,
    height: 130,
    fill: "white",
    transform: "translate(0.379883 0.210938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationLogo1Bw);
export default __webpack_public_path__ + "static/media/illustration-logo-1-bw.ebf875fb61b9b8728eb9b968a1b31cd8.svg";
export { ForwardRef as ReactComponent };